import gql from 'graphql-tag';

const SIMULATION_DETAILS_QUERY = gql`
  query ($simulationId: ID!, $language: String!) {  
    simulation(simulationId: $simulationId, language: $language){
      simulationId
      contractNumber
      calculationRequestDate
      situationDate
      dateClosingFiscalYear
      calculationQuestions {
        questionLabel
        answer
      }
      customer {
        firstName
        lastName
        startDateCareer    
        profession{
          professionId
        }
        legalPensionAge
        monthsIndependentBefore2021
        maritalState {
          maritalStateId
          name
        }
        birthDate

      }
      enterprise {
        name
      }
      calculationResults {
        calculationType{
          calculationTypeId
          name
        }
        remarkMedicalQuestions
        remarkBeneficiary
        annualPremiumPensionAndDeath
        annualPremiumOtherGuarantees
        annualPremiumAllIn
        backservice
        futureValuePremiumPayingFiscal
        neededSalary
        calculationResultStatusId
      }
      customerEnterprise {
        startDate
      }
      calculationDetails {
        canBeProcessed
        comment
        canBeAccepted
        paidPremium
        yearOfPayment
        paidBackService
        acceptedDate
        processedDate
        commissionBackService
        annualPremiumPensionAndDeath
        annualPremiumOtherGuarantees
        annualPremiumAllIn
        futureValuePremiumPayingFiscal
        totalSalary
        eightyPercOfSalary
        estimatedLegalPension
        isNewCalculationC33
        eightyPercOfSalaryExclLegalPension
        totalCareerCoefficient
        presentValue
        correction
        maximumYearlyRent
        rentToCapitalCoefficient
        maximumCapitalToInsureInclPB
        maximumCapitalToInsure
        insuredPremiumFreeValue
        insuredPremiumPayingValue
        maximumCapitalToInsureExclOtherContracts
        maximumCapitalToInsurePast
        pastYearsInEnterprise
        futureYears
        pastYearsBeforeEnterprise
        dueDate
        brokerComment
        startDateCareerInEnterprise
        maritalState {
          maritalStateId
          name
        }
      }
      salaries{
        salaryValue
        salaryTypeId
        salaryId
      }
      otherContracts {
         contractType {
          contractTypeId
          name
        }   
        contractNumber
        insuranceCompanyName
        endAge
        futureValuePremiumFreeFiscal
        futureValuePremiumPayingFiscal
        situationDate
      }
    }
  }
`;

export default SIMULATION_DETAILS_QUERY;
